module.exports = __webpack_public_path__ + "static/media/angle-down.689e81eb.svg";